import { useEffect, useRef } from 'react';

import { useAppSelector } from '@/Application/Hooks/Redux';
import { EShippingSubType } from '@/modules/cart/domain/Cart';
import { BuyNowEventInteractiveCategories } from '@/modules/shared/utils/gtmEvents/buyNowTypes';
import { sendEvent } from '@/modules/shared/utils/gtmEvents/sendEvents/sendBuyNowEvents';
import type { DeliveryGroup } from '@/modules/shippingMethod/domain/ShippingMethod';
import {
  getNearestDate,
  getNearestDateByType,
  getShippingPrice
} from '@/Pages/BuyNowPage/PaymentAndShipping/partials/ShippingMethods/utils';

export const useSendDeliveryOffers = (
  generalShippingMethods: DeliveryGroup[]
) => {
  const cart = useAppSelector((state) => state.buyNow.cart.data);
  const gtmEventSentRef = useRef(false);

  useEffect(() => {
    if (
      !gtmEventSentRef.current &&
      generalShippingMethods &&
      generalShippingMethods.length > 0 &&
      cart
    ) {
      const firstGroup = generalShippingMethods[0];
      const shippingOptions = firstGroup.shippingOptions || [];
      const pickupOptions = firstGroup.pickupOptions || [];

      const skus = firstGroup.productList
        .map((product) => product.productSKU)
        .join('/');

      const nearestDeliveryDate = getNearestDate(
        shippingOptions,
        pickupOptions
      );

      const nearestDespachoDate = getNearestDateByType(
        shippingOptions,
        EShippingSubType.HOME
      );
      const nearestRetiroDate = getNearestDateByType(
        pickupOptions,
        EShippingSubType.IN_STORE
      );
      const nearestCopecDate = getNearestDateByType(
        pickupOptions,
        EShippingSubType.COPEC
      );

      const totalProductPrice = cart?.lineItems?.reduce(
        (total, product) => total + product?.price?.value?.centAmount,
        0
      );

      const shippingPrice = getShippingPrice(firstGroup?.shippingOptions);
      const vendedor = firstGroup?.classificationGroupMeta?.sellerNameIndex;
      const deliveryGroupIndex = '1-1';

      sendEvent({
        event: 'baseEvent',
        extraFields: {
          'event-interactive-category':
            BuyNowEventInteractiveCategories.CheckoutInfo,
          'event-interactive-accion': skus,
          'event-interactive-tag': nearestDeliveryDate,
          'event-interactive-value': totalProductPrice,
          'event-interactive-leadtime_despacho': nearestDespachoDate,
          'event-interactive-leadtime_retiro': nearestRetiroDate,
          'event-interactive-leadtime_puntoscopec': nearestCopecDate,
          dimension46: shippingPrice,
          dimension47: deliveryGroupIndex,
          'event-interactive-vendedor': vendedor
        }
      });

      gtmEventSentRef.current = true;
    }
  }, [generalShippingMethods, cart]);
};
